<template>
	<section id="cliente">
		<Notification corner="bottom-right" :closed="true" />
		<container pathName="create">
			<div class="buttonAdd" @click="openModal()">ADICIONAR</div>
			<load-content v-if="loadContent && clienteList.length === 0" />
			<div class="table-wrapper" v-if="clienteList.length > 0">
				<div class="table">
					<table>
						<thead>
							<tr>
								<th>Identificador</th>
								<th>Instituição</th>
								<th>Responsável</th>
								<!-- <th>E-mail</th>
								<th>Status</th> -->
								<th>Ações</th>
							</tr>
						</thead>

						<tbody>
							<tr class="fields" v-for="cliente in clienteList" :key="cliente.id">
								<td><span>{{ cliente.id }}</span></td>
								<td><span>{{ cliente.instituicao }}</span></td>
								<td><span>{{ cliente.nome }}</span></td>
								<!-- <td><span>{{ cliente.email }}</span></td>
								<td class="field-status">
									<item-status :status="cliente.flagAtivo"></item-status>
								</td> -->
								<td class="acoes">
									<div>
										<button class="edit" @click="openModal(cliente)"><i class="fas fa-pen"></i></button>
										<button-remove class="delete" :onClick="() => openModalDelete(cliente)"></button-remove>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="paginacao" v-if="totalDeItens > 20">
					<Pagination :totalDeItens="totalDeItens" :currentPage="currentPage" @pagina="getCurrentPage" />
				</div>
			</div>
			<div class="not-found" v-else-if="inicial">
					Não existe nenhum Cliente cadastrado :)
			</div>
		</container>

		<!-- Cadastrar/Editar Cliente -->
		<div class="modal-blackscreen" v-if="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
			<div class="modal">
				<div class="adicionar">
					<i class="fas fa-plus"></i>
					<p>{{editarCliente ? 'Atualizar': 'Adicionar' }} </p>
				</div>
				<input type="text" v-on:keyup.enter="() => salvarCliente()" placeholder="Nome da Instituição" v-model="cliente.instituicao" />
				<input type="text" v-on:keyup.enter="() => salvarCliente()" placeholder="Nome do Responsável" v-model="cliente.nome" />
				<div class="dominio">
					<input type="button" value="Adicionar Domínio" @click="adicionarDominio"/>
					<div class="list" v-if="cliente.dominios.length > 0">
						<div v-for="(dominio, index) in cliente.dominios" :key="index">
							<input type="text" v-model="dominio.url" :key="index" @blur="formataUrl(index)" />
							<button-remove class="delete" :onClick="() => deleteDominio(index)"></button-remove>
						</div>
					</div>
				</div>
				<div class="botoes">
					<button-action type="button" :onClick="closeModal" class="xs default" style="margin-right: 10px;">Cancelar</button-action>
					<button-action type="button" :onClick="() => salvarCliente()" class="xs blue">{{ editarCliente  ? 'ATUALIZAR' : 'ADICIONAR'}}</button-action>
				</div>
			</div>
		</div>

		<!-- Modal para confirmação de exclusão de Cliente -->
		<Modal v-if="isModalDeleteVisible" @close="() => this.isModalDeleteVisible = !this.isModalDeleteVisible">
			<template v-slot:body>
				<p class="texto">Deseja remover o Cliente <i>{{ removeItem.nome }}</i>?</p>
			</template>

			<template v-slot:footer>
				<button-action type="button" :onClick="() => deleteCliente(removeItem.id)" class="xs danger">Confirmar</button-action>
				<button-action type="button" :onClick="closeModalDelete" class="xs default">Cancelar</button-action>
			</template>
		</Modal>

	</section>
</template>

<script>
import ButtonRemove from '@/components/shared/ButtonRemove'
import Container from '@/components/shared/Container'
// import ItemStatus from '@/components/shared/ItemStatus'
import Pagination from '@/components/shared/Pagination'
import { clientes } from '@/services/clientes'
import Modal from '@/components/shared/Modal'
import LoadContent from '@/components/shared/LoadContent'
import ButtonAction from '@/components/shared/ButtonAction'

export default {
	name: 'ClienteList',
	components: { Container, Pagination, ButtonRemove, Modal, LoadContent, ButtonAction },
	data () {
		return {
			clienteList: [],
			isModalVisible: false,
			totalDeItens: 0,
			currentPage: 1,
			isModalDeleteVisible: false,
			removeItem: {},
			inicial: false,
			loadContent: true,
			cliente: {
				id: '',
				nome: '',
				instituicao: '',
				dominios: []
			},
			params: { },
			editarCliente: false
		}
	},
	async created () {
		this.getCurrentPage()
	},
	methods: {
		async getCurrentPage () {
			this.loadContent = true
			this.params = {
				...this.$route.query
			}

			if (this.params && this.params.skip) {
				this.currentPage = parseInt(this.params.skip)
				this.params.skip = parseInt(this.params.skip) - 1
			} else {
				this.currentPage = 1
				this.params.skip = 0
			}
			try {
				const cliente = await clientes.find(this.params)
				this.totalDeItens = cliente.body.TotalDeClientes
				this.clienteList = cliente.body
				this.loadContent = false
			} catch (err) {
				this.loadContent = false
			}
			this.inicial = true
			this.loadContent = false
		},
		async adicionarDominio () {
			this.cliente.dominios.push({ url: '' })
		},
		async deleteCliente (id) {
			this.isModalDeleteVisible = false
			try {
				await clientes.delete(id)
				window.notificationEM.open('', 'Cliente Excluído com sucesso!', 'success')
				const cliente = await clientes.find(this.params)
				this.totalDeItens = cliente.body.TotalDeClientes
				this.clienteList = cliente.body
				this.loadContent = false
			} catch (error) {
				window.notificationEM.open('', error.response.data.msg, 'error')
			}
			this.removeItem = {}
		},
		openModal (cli) {
			if (cli) {
				this.cliente.id = cli.id
				this.cliente.nome = cli.nome
				this.cliente.instituicao = cli.instituicao
				if (cli.dominios) {
					cli.dominios.split(',').map(dominio => {
						const urlDominio = {
							url: dominio
						}
						this.cliente.dominios.push(urlDominio)
					})
				}
				this.editarCliente = true
			} else {
				this.editarCliente = false
			}
			this.isModalVisible = true
		},
		closeModal () {
			this.isModalVisible = false
			this.editarCliente = false
			this.cliente = {
				...this.cliente,
				id: '',
				nome: '',
				instituicao: '',
				dominios: []
			}
		},
		deleteDominio (index) {
			this.cliente.dominios.splice(index, 1)
		},
		openModalDelete (cli) {
			this.isModalDeleteVisible = true
			this.removeItem = cli
		},
		closeModalDelete () {
			this.isModalDeleteVisible = false
			this.removeItem = {}
		},
		formataUrl (index) {
			this.cliente.dominios[index].url = this.cliente.dominios[index].url.replace(/https:\/\/|http:\/\//, '')
			this.cliente.dominios[index].url = this.cliente.dominios[index].url.replace(/\//, '')
		},
		async salvarCliente () {
			try {
				if (this.editarCliente) {
					await clientes.update(this.cliente.id, this.cliente)
					this.closeModal()
					this.getCurrentPage()
					window.notificationEM.open('', 'Cliente atualizado com sucesso!', 'success')
				} else {
					this.editarCuradoria = false
					await clientes.create(this.cliente)
					this.closeModal()
					window.notificationEM.open('', 'Cliente Cadastrado com sucesso!', 'success')
				}
				const cliente = await clientes.find(this.params)
				this.totalDeItens = cliente.body.TotalDeClientes
				this.clienteList = cliente.body
				this.loadContent = false
			} catch (error) {
				window.notificationEM.open('', error.response.data.msg, 'error')
			}
			this.closeModal()
		}
	}
}
</script>

<style lang="scss" scoped>
#cliente {
	.table-wrapper {
		.table {
			display:flex;
			padding: 5px 0px 5px;

			th:last-child {
				display: flex;
				justify-content: center;
			}

			td {
				vertical-align: middle;
			}

			td:last-child {
				display: flex;
				justify-content: center;
			}

			.acoes {
				width: auto;

				div {
					display: flex;
				}

				.edit {
					margin-right: 10px;
					display: flex;
					justify-content: center;
					align-items: center;
					border: none;
					border-radius: 5px;
					width: 28px;
					height: 28px;
					background-color: #3367d6;
					color:#fff;
					font-weight: $font-weight-default-bolder;
					font-size: $font-size;
					cursor: pointer;
					outline: none;

					&:disabled {
						opacity: .3;
						cursor: default;
					}
				}
			}

			.paginacao{
				width:100%;
			}
		}
	}
	.buttonAdd {
		display: flex;
		align-items: center;
		background-color: #3367d6;
		border-radius: 5px;
		cursor: pointer;
		color: #fff;
		font-family: $font-family;
		font-size: 1.0em;
		font-weight: 300;
		text-transform: uppercase;
		position: absolute;
		right: 30px;
		margin-bottom: 50px;
		top: 20px;
		padding: 16px 49px 15px 47px;
		justify-content: center;
	}

	.title-box {
		background-color: $main-color;
		color: #fff;
		font-family: $font-family;
		font-size: $font-size;
		font-weight: $font-weight-labels;
		display: grid;
		grid-template-columns: 3fr 4fr 1fr;
		padding: 10px;
		width: 99%;
		margin-top: 20px;
		margin-bottom: -15px;
	}

	.table-wrapper {
		padding-top: 30px;
		color: #000;
		width: 99%;

		.row {
			display: flex;
			align-items: center;
			background-color:#ebf0f9;
			margin-bottom: 20px;

			&:nth-child(n) {
				padding: 10px;
			}

			.column1 {
				background-color: $main-color;
				color: #fff;
				height: 25px;
				margin-right: 8px;
				width: 25px;
				font-size: 30px;
				padding-top: 10px;
			}

			.rowSub {
				flex-direction: column;
			}
		}
	}

	.table-wrapper .tree-menu:nth-child(n) {
		margin-bottom: 10px;
	}

	.modal-blackscreen {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2;

		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
		background-color: #0007;

		.modal {
			position: fixed;
			z-index: 1;
			width: 700px;
			min-height: 200px;
			padding: 20px;
			margin: 0 50px auto;
			max-height: 700px;
			overflow: overlay;
			background-color: #fff;
			color: #000;
			box-shadow: #6667 1px 1px 3px 3px;
			@media only screen and (max-width: 1200px) {
				width: calc(100% - 40px);
			}

			.adicionar {
				display: flex;
				align-items: center;
				margin-bottom: 15px;

				i {
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: $main-color;
					font-size: 19px;
					height: 30px;
					width: 30px;
					margin-right: 6px;
				}

				p {
					color: $main-color;
					font-weight: bold;
					font-size: 17px;
					text-transform: uppercase;
				}
			}

			input {
				width: 100%;
				padding: 10px;
				margin-top: 10px;
				border: 1px solid #CCC;
				border-radius: 5px;

				&::placeholder {
					text-transform: uppercase;
				}
			}

			.botoes {
				display: flex;
				align-items: flex-end;
				justify-content: flex-end;
				width: 100%;
				margin-top: 30px;

				button {
					width: unset;
					padding-left: 20px;
					padding-right: 20px;
					text-transform: uppercase;
					font-family: $font-family;
				}
			}
		}
	}
	.not-found {
		margin-top: 50px;
		color: #000;
		text-align: center;
	}
	.dominio {
		.list {
			div {
				display: flex;
				justify-content: center;
				align-items: center;
				button {
					margin-top: 10px;
					margin-left: 5px;
				}
			}
		}
	}
}

</style>
